import { CellContext, createColumnHelper } from "@tanstack/react-table";
import React, { useState } from "react";
import moment from "moment";
import { Col, Offcanvas } from "react-bootstrap";
import IConfirmacionMantenedor from "../../../../entities/helper/IConfirmacionMantenedor";
import { IEstadoDesviacion } from "../../../../entities/IEstadoDesviacion";
import IGerencia from "../../../../entities/IGerencia";
import IAuditoria from "../../../../entities/IAuditoria";
import ILogMantenedor from "../../../../entities/ILogMantenedor";
import ISubContratista from "../../../../entities/ISubContratista";
import IUnidad from "../../../../entities/IUnidad";
import IVicePresidencia from "../../../../entities/IVicePresidencia";
import { shortDate } from "../../../../helpers/dateHelper";
import { ITipo_Campo } from "../../../../helpers/IFormHelper";
import { getAPI, postAPI } from "../../../../helpers/httpHelper";
import { usePromiseEffect } from "../../../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../../../helpers/userHelper";
import {
  API_ADMIN_GERENCIA,
  API_ADMIN_MANTENEDOR_ITEM_NORMATIVA,
  API_ADMIN_UNIDAD,
  ROW_COUNT,
  URL_SUPPORT,
  API_ADMIN_AUDITORIA,
} from "../../../../helpers/variableHelper";
import AdminLista from "../../AdminLista";
import RenderForm from "../../RenderForm";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ICurrentUser from "../../../../entities/helper/ICurrentUser";
import Select from "react-select";
import { IComboboxOption } from "../../../../entities/helper/IComboboxOption";
import AuditoriaService from "../../../../services/AuditoriaService";
import VppService from "../../../../services/VppService";
import CscService from "../../../../services/CscService";
import CustomToast from "../../../../cross/CustomToast";
import { cParamsActive, cParamsActiveOrderTitle } from "../../../../helpers/paramsHelper";
import { updateFilter, updateSelectedField } from "../UtilsMantenedor";
import { downloadFile } from "../../../../helpers/fileHelper";
import RenderTitle from "../../../../controls/RenderTitle";
import RenderValue from "../../../../controls/RenderValue";
import RenderLink from "../../../../controls/RenderLink";
const MySwal = withReactContent(Swal);
interface IMantenedorItemProps {
  items?: Array<any>;
  cbVicepresidencia?: Array<IVicePresidencia>;
  cbGerenciaSubgerencia?: Array<IGerencia>;
  cbUnidadProyecto?: Array<IUnidad>;
  cbContratistaSubcontratista?: Array<ISubContratista>;
  cbEstadoDesviacion?: Array<IEstadoDesviacion>;
  itemsArrCambios?: Array<IConfirmacionMantenedor>;
  is_Test?: boolean;
  openPopup?: boolean;
  isEdit?: boolean;
}

const ButtonRender = (infomi: any, confirm2: any, token: string) => {
  let desactivar = infomi.row.original.ACTIVO ? "Desactivar" : "Activar";
  return (
    <button
      className="btnIcono"
      title={desactivar}
      onClick={() => {
        MySwal.fire({
          html: (
            <div>
              <h3>
                ¿Desea {desactivar.toLowerCase()} el registro {infomi.row.original.CORRELATIVO}?
              </h3>
            </div>
          ),
          text: "",
          icon: "question",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showCloseButton: true,
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            if (result.isConfirmed) {
              MySwal.fire({
                html: (
                  <div>
                    <h4>Ingrese un Motivo:</h4>
                  </div>
                ),
                input: "textarea",
                inputAttributes: {
                  autocapitalize: "off",
                },
                showCancelButton: true,
                confirmButtonText: `<i class="bi bi-eye"></i>${desactivar}`,
                cancelButtonText: "Cancelar",
                showLoaderOnConfirm: true,
                preConfirm: async (txtMotivo) => {
                  await confirm2(
                    txtMotivo,
                    infomi.row.original.ID_ITEM_NORMATIVO as number,
                    infomi.row.original.ACTIVO,
                    infomi.row.original.CORRELATIVO ?? ""
                  );
                  AuditoriaService.GenerarPDFPlan(token, infomi.row.original.ID);
                  AuditoriaService.GenerarPDFInforme(token, infomi.row.original.ID);
                },
                allowOutsideClick: () => !Swal.isLoading(),
              }).then((result) => {
                if (result.isConfirmed) {
                  console.log("");
                }
              });
            }
          }
        });
      }}>
      <i className={infomi.row.original.ACTIVO ? "fs-5 bi bi-eye-slash btnIconoActive" : "fs-5 bi bi-eye btnIconoInactive"} />
    </button>
  );
};

export default function MantenedorItem({
  is_Test,
  isEdit,
  openPopup,
  items,
  cbVicepresidencia,
  cbUnidadProyecto,
  cbContratistaSubcontratista,
  cbGerenciaSubgerencia,
  itemsArrCambios,
}: IMantenedorItemProps) {
  let paramsActive = cParamsActiveOrderTitle;
  const userInfo = cognitoUserToken();
  const [pageSize, setPageSize] = useState(ROW_COUNT);
  const [token, setToken] = useState("");
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [comboVccMI, setComboVccMI] = useState<Array<IVicePresidencia>>(cbVicepresidencia || []);
  const [comboUPMI, setComboUPMI] = useState<Array<IUnidad>>(cbUnidadProyecto || []);
  const [comboGSGMI, setComboGSGMI] = useState<Array<IGerencia>>(cbGerenciaSubgerencia || []);
  const [comboCSCMD, setComboCSCMD] = useState<Array<ISubContratista>>(cbContratistaSubcontratista || []);
  const [comboCSCMI, setComboCSCMI] = useState<Array<ISubContratista>>([]);

  const [isEditColum, setIsEditColumMI] = useState<boolean>(isEdit ?? false);
  const [editColumnInfo, setEditColumnInfoMI] = useState<any>();
  const [listItems, setListItemsMI] = useState<Array<any>>(items ?? []);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [showToast, setShowToastMI] = useState(false);
  const [hideTable, setHideTable] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [arrCambiosFormMI, setArrCambiosFormMI] = useState<Array<IConfirmacionMantenedor>>(itemsArrCambios || []);
  const [isOpenPopUpGuardarCambiosMI, setIsOpenPopUpGuardarCambiosMI] = useState<boolean>(openPopup ?? false);

  const refTxtCorrMI = React.createRef<HTMLInputElement>();
  const refTxtAnioMI = React.createRef<HTMLInputElement>();
  const [refComboVccMI, setValComboVccMI] = useState<IComboboxOption | null>(null);
  const [refComboUPMI, setValComboUPMI] = useState<IComboboxOption | null>(null);
  const [refComboGSGMI, setValComboGSGMI] = useState<IComboboxOption | null>(null);
  const [refComboCSCMI, setValComboCSCMI] = useState<IComboboxOption | null>(null);
  const [refComboEDMI, setValComboEDMI] = useState<IComboboxOption | null>(null);
  const [refComboCSCMD, setValComboCSC] = useState<IComboboxOption | null>(null);
  const [selectedFieldMI, setSelectedFieldMI] = useState({} as any);
  const [isSendingData, setIsSendingData] = useState(false);
  const refTxtMotivo = React.createRef<HTMLTextAreaElement>();

  const columnHelperMantItem = createColumnHelper<IAuditoria>();
  const columnHelperConfirmacionCambios = createColumnHelper<IConfirmacionMantenedor>();
  console.log(comboCSCMI);
  const changeField = (id: string, valor: any) => {
    let sf: any = updateSelectedField(id, valor);
    setSelectedFieldMI(sf);
  };
  const component = (titulo: string) => {
    return <RenderTitle title={titulo} />;
  };

  const componentValue = (value: any, type?: number) => {
    return <RenderValue value={value} type={type} />;
  };

  const componentLink = (value: any) => {
    return <RenderLink value={value} />;
  };

  const confirm2 = async (txtMotivo: any, id_item: number, activo: boolean, correlativo: string) => {
    if (!txtMotivo) {
      Swal.showValidationMessage(`Debe ingresar un motivo`);
    } else {
      await AuditoriaService.desactivarRegistroAuditoriaIN(token, {
        ID_REGISTRO: id_item,
        AUTOR: currentUser?.email as string,
        AUTOR_DISPLAY: currentUser?.fullname as string,
        CAMPO: "N/A",
        EDITOR: currentUser?.email as string,
        EDITOR_DISPLAY: currentUser?.fullname as string,
        MODULO: "AUDITORIA",
        TABLA: "ITEM_NORMATIVA",
        MOTIVO: txtMotivo,
        VALOR_INICIAL: "N/A",
        DESACTIVAR: activo,
        FECHA_CREACION: new Date(),
        FECHA_MODIFICACION: new Date(),
        VALOR_FINAL: "N/A",
        ACCION: activo ? "DESACTIVAR" : "ACTIVAR",
        CORRELATIVO: correlativo,
      });
      await handleBuscarMI();
    }
  };
  let columnsDef = [
    columnHelperMantItem.accessor((rowmi) => rowmi.CORRELATIVO, {
      id: "CORRELATIVO_COLUMNA",
      cell: (infomi: CellContext<IAuditoria, string>) => componentValue(infomi.getValue()),
      header: () => component("Correlativo"),
      hide: false,
      title: "Correlativo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `AU."CORRELATIVO"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.ID, {
      id: "DESACTIVAR",
      cell: (infomi: CellContext<IAuditoria, number>) =>
        ButtonRender(
          infomi,
          (txt: any, id: any, activo: any, correlativo: any) => {
            confirm2(txt, id, activo, correlativo);
          },
          token
        ),
      header: () => component("Activar / Desactivar"),
      tipo: ITipo_Campo.text,
      className: "ps-3",
      disableSorting: true,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.ACTIVO, {
      id: "ACTIVO",
      cell: (info: CellContext<IAuditoria, boolean>) => <i>{info.getValue() === true ? "Sí" : "No"}</i>,
      header: () => <span>Activo</span>,
      tipo: ITipo_Campo.check,
      title: "Activo",
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.PROGRAMA, {
      id: "PROGRAMA",
      cell: (infomi: CellContext<IAuditoria, string>) => componentValue(infomi.getValue()),
      header: () => component("Programa"),
      hide: false,
      title: "Programa",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"PROGRAMA"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.ANIO, {
      id: "ANIO_COLUMNA",
      cell: (infomi: CellContext<IAuditoria, string>) => componentValue(infomi.getValue()),
      header: () => component("Año"),
      hide: false,
      title: "Año",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"ANIO"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.VICEPRESIDENCIA, {
      id: "VICEPRESIDENCIA_COLUMNA",
      cell: (infomi: CellContext<IAuditoria, string>) => componentValue(infomi.getValue()),
      header: () => component("Vicepresidencia"),
      hide: false,
      title: "Vicepresidencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"VICEPRESIDENCIA"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.GERENCIA_SUBGERENCIA, {
      id: "GERENCIA_SUBGERENCIA_COLUMNA",
      cell: (infomi: CellContext<IAuditoria, string>) => componentValue(infomi.getValue()),
      header: () => component("Gerencia Subgerencia"),
      hide: false,
      title: "Gerencia Subgerencia",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"GERENCIA_SUBGERENCIA"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.UNIDAD_PROYECTO, {
      id: "UNIDAD_PROYECTO_COLUMNA",
      cell: (infomi: CellContext<IAuditoria, string>) => componentValue(infomi.getValue()),
      header: () => component("Unidad Proyecto"),
      hide: false,
      title: "Unidad Proyecto",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"UNIDAD_PROYECTO"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.TIPO_AUDITORIA, {
      id: "TIPO_AUDITORIA",
      cell: (infomi: CellContext<IAuditoria, string>) => componentValue(infomi.getValue()),
      header: () => component("Tipo Auditoría"),
      hide: false,
      title: "Tipo Auditoría",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"TIPO_AUDITORIA"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.REQUISITO_NORMATIVO, {
      id: "REQUISITO_NORMATIVO",
      cell: (infomi: CellContext<IAuditoria, string>) => componentValue(infomi.getValue()),
      header: () => component("Requisito Normativo"),
      hide: false,
      title: "Requisito Normativo",
      tipo: ITipo_Campo.text,
      className: "colorGris",
      sortId: `"REQUISITO_NORMATIVO"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.FECHA_CREACION, {
      id: "FECHA_CREACION",
      cell: (infomi: CellContext<IAuditoria, string>) => componentValue(shortDate(infomi.getValue())),
      header: () => component("Fecha Creación"),
      hide: false,
      title: "Fecha Creación",
      tipo: ITipo_Campo.date,
      className: "colorGris",
      sortId: `AU."FECHA_CREACION"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => shortDate(rowmi.FECHA), {
      id: "FECHA",
      cell: (infomi: CellContext<IAuditoria, string>) => componentLink(infomi.getValue()),
      header: () => component("Fecha"),
      hide: false,
      title: "Fecha",
      tipo: ITipo_Campo.date,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMI(cell);
        setIsEditColumMI(true);
        setIsSendingData(false);
      },
      sortId: `INO."FECHA"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.HORA_INICIO, {
      id: "HORA_INICIO",
      cell: (infomi: CellContext<IAuditoria, string>) => componentLink(infomi.getValue()),
      header: () => component("Hora Inicio"),
      hide: false,
      title: "Hora Inicio",
      tipo: ITipo_Campo.text,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMI(cell);
        setIsEditColumMI(true);
        setIsSendingData(false);
      },
      sortId: `INO."HORA_INICIO"`,
    } as any),
    columnHelperMantItem.accessor((rowmi) => rowmi.HORA_FINAL, {
      id: "HORA_FINAL",
      cell: (infomi: CellContext<IAuditoria, string>) => componentLink(infomi.getValue()),
      header: () => component("Hora Término"),
      hide: false,
      title: "Hora Término",
      tipo: ITipo_Campo.text,
      onSelectColumn: (cell: any) => {
        setEditColumnInfoMI(cell);
        setIsEditColumMI(true);
        setIsSendingData(false);
      },
      sortId: `INO."HORA_FINAL"`,
    } as any),
  ] as any;

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    let currUser = await cognitoUserInfo();
    setCurrentUser(currUser);

    const comboVccMI = is_Test ? [] : (await VppService.getAll(token, paramsActive)).result.data;
    setComboVccMI(comboVccMI);
    const comboCSCMI = is_Test ? [] : (await CscService.getAll(token, paramsActive)).result.data;
    setComboCSCMI(comboCSCMI);
    const comboCSCMD = (await CscService.getAll(token, paramsActive)).result.data;
    setComboCSCMD(comboCSCMD);
  }, []);

  const paging = (page: any) => {
    setPage(page);
    filtermi({ PAGINA: page }, true);
  };

  const filtermi = (filtermi: any, page: boolean = false, size = pageSize) => {
    filtermi = updateFilter(filtermi, size, page);
    setPage(filtermi.PAGINA);

    const valCorr = refTxtCorrMI.current?.value;
    const valAnio = refTxtAnioMI.current?.value;
    const valVcc = refComboVccMI?.value === "Seleccione" ? "" : refComboVccMI?.value;
    const valUP = refComboUPMI?.value === "Seleccione" ? "" : refComboUPMI?.value;
    const valGSG = refComboGSGMI?.value === "Seleccione" ? "" : refComboGSGMI?.value;
    const valCSC = refComboCSCMI?.value === "Seleccione" ? "" : refComboCSCMI?.value;
    const valED = refComboEDMI?.value === "Seleccione" ? "" : refComboEDMI?.value;
    filtermi.UNIDAD_PROYECTO = valUP;
    filtermi.GERENCIA_SUBGERENCIA = valGSG;
    filtermi.VICEPRESIDENCIA = valVcc;
    filtermi.CONTRATISTA_SUBCONTRATISTA = valCSC;
    filtermi.ESTADO = valED;
    filtermi.CORRELATIVO = valCorr;
    filtermi.ANIO = valAnio;

    getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_ITEM_NORMATIVA}`, { Authorization: `Bearer ${token}` }, filtermi)
      .then((result) => {
        setIsLoading(false);
        setListItemsMI(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };

  const editmi = (value: any, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    value.AUTOR = "";
    value.AUTOR_DISPLAY = "";
    value.EDITOR = "";
    value.EDITOR_DISPLAY = "";

    if (value.ID === "") {
      delete value.ID;
    }
  };

  const exportFileMI = () => {
    const valCorr = refTxtCorrMI.current?.value;
    const valVcc = refComboVccMI?.value;
    const valAnio = refTxtAnioMI.current?.value;
    const valUP = refComboUPMI?.value;
    const valGSG = refComboGSGMI?.value;
    const valCSC = refComboCSCMI?.value;
    const valED = refComboEDMI?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      ESTADO: valED,
      CORRELATIVO: valCorr,
      ANIO: valAnio,
    };
    getAPI(`${URL_SUPPORT}${API_ADMIN_AUDITORIA}/ExportMantenedorItemNormativa`, { Authorization: `Bearer ${token}` }, params).then((r) => {
      downloadFile(r.result);
    });
  };

  const searchValidationMI = () => {
    let flag = true;

    return flag;
  };

  const confirm = () => {
    let arrItems: Array<IAuditoria> = is_Test ? items ?? [] : [];
    let arrCambios = is_Test ? itemsArrCambios ?? [] : arrCambiosFormMI;
    let arrLogs: Array<ILogMantenedor> = [];

    arrCambios.forEach((ac) => {
      if (!arrItems.find((d) => d.ID_ITEM_NORMATIVO === ac.ID)) {
        arrItems.push(ac.OBJETO_REF);
      }
    });

    arrItems.forEach((d: any) => {
      arrCambios
        .filter((ac) => ac.ID === d.ID_ITEM_NORMATIVO)
        .forEach((ac) => {
          let log: ILogMantenedor = {
            ID: null,
            MODULO: "AUDITORIA",
            TABLA: "ITEM_NORMATIVA",
            ID_REGISTRO: d.ID,
            CAMPO: ac.CAMPO_EDITADO_ID,
            VALOR_INICIAL: ac.VALOR_ORIGINAL,
            VALOR_FINAL: null,
            MOTIVO: refTxtMotivo.current?.value || "",
            AUTOR: currentUser?.email || "",
            FECHA_CREACION: new Date(),
            EDITOR: "",
            FECHA_MODIFICACION: new Date(),
            AUTOR_DISPLAY: currentUser?.fullname || "",
            EDITOR_DISPLAY: "",
            CORRELATIVO: d.CORRELATIVO,
          };

          if (ac.TIPO === ITipo_Campo.user) {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID];
            d[ac.CAMPO_EDITADO_ID + "_DISPLAY"] = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
            log.VALOR_FINAL = ac.VALOR_NUEVO[ac.CAMPO_EDITADO_ID + "_DISPLAY"];
          } else {
            d[ac.CAMPO_EDITADO_ID] = ac.VALOR_NUEVO;
            log.VALOR_FINAL = ac.VALOR_NUEVO;
          }
          arrLogs.push(log);
        });
    });

    let value = {
      LOG_MANTENEDOR: arrLogs,
      ITEM: arrItems,
    };

    postAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_ITEM_NORMATIVA}`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        postItemNormativa(result);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const postItemNormativa = (result: any) => {
    let data = result.result.data;
    console.log(data);
    let params = { PAGINA: page };
    filtermi(params);
    if (refTxtMotivo.current) {
      refTxtMotivo.current.value = "";
    }
    setArrCambiosFormMI([]);
    setIsOpenPopUpGuardarCambiosMI(false);
    setShowToastMI(true);
  };

  const handleBuscarMI = async () => {
    setIsLoading(true);
    const valCorr = refTxtCorrMI.current?.value;
    const valAnio = refTxtAnioMI.current?.value;
    const valVcc = refComboVccMI?.value === "Seleccione" ? "" : refComboVccMI?.value;
    const valUP = refComboUPMI?.value === "Seleccione" ? "" : refComboUPMI?.value;
    const valGSG = refComboGSGMI?.value === "Seleccione" ? "" : refComboGSGMI?.value;
    const valCSC = refComboCSCMI?.value === "Seleccione" ? "" : refComboCSCMI?.value;
    const valED = refComboEDMI?.value === "Seleccione" ? "" : refComboEDMI?.value;
    let params = {
      PAGINA: 1,
      PAGINADO: ROW_COUNT,
      ORDENADOPOR: "ID",
      ORIENTACION: "DESC",
      UNIDAD_PROYECTO: valUP,
      GERENCIA_SUBGERENCIA: valGSG,
      VICEPRESIDENCIA: valVcc,
      CONTRATISTA_SUBCONTRATISTA: valCSC,
      ESTADO: valED,
      CORRELATIVO: valCorr,
      ANIO: valAnio,
    };

    if (searchValidationMI()) {
      const result = is_Test
        ? { data: [], pages: 1 }
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_MANTENEDOR_ITEM_NORMATIVA}`, { Authorization: `Bearer ${token}` }, params)).result;
      let list = result.data;
      setListItemsMI(list);
      let pages = result.pages;
      setPages(pages);
      setHideTable(false);
      setIsLoading(false);
    }
  };

  return (
    <section>
      <div className="row">
        <button
          hidden={true}
          data-testid="btnbuscarmi"
          onClick={() => {
            handleBuscarMI();
          }}></button>
        <button
          hidden={true}
          data-testid="btnexport"
          onClick={() => {
            exportFileMI();
          }}></button>
        <button
          hidden={true}
          data-testid="btnedit"
          onClick={() => {
            editmi({ AUTOR: "", AUTOR_DISPLAY: "", EDITOR: "", EDITOR_DISPLAY: "", ID: "" }, {});
          }}></button>
        <button
          hidden={true}
          data-testid="btnconfirm"
          onClick={() => {
            confirm();
          }}></button>
        <button
          hidden={true}
          data-testid="btnconfirm2"
          onClick={() => {
            confirm2("", 1, true, "");
          }}></button>
        <button
          hidden={true}
          data-testid="btnpaging"
          onClick={() => {
            paging(1);
          }}></button>
        <button
          hidden={true}
          data-testid="btnpost"
          onClick={() => {
            postItemNormativa({ result: { data: {} } });
          }}></button>
        <div className="col-12">
          <div className="rounded bg-white p-2 shadow">
            <div className="container-fluid mb-2">
              <h1 className="titPrincipal colorTit mt-2">Mantenedor Auditoría - Ítem Normativa</h1>
              <div className="alert alert-warning p-1 mb-2" role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Este módulo es de uso exclusivo de administración y su uso esta bajo su responsabilidad
                </small>
              </div>
              <div className="row mb-1 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <Col>
                    <label>Búsqueda por Correlativo:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtCorrMI} className="form-control" />
                  </Col>
                </Col>
                <Col xs="12" md="6" lg="6">
                  <Col>
                    <label>Búsqueda por Año:</label>
                  </Col>
                  <Col>
                    <input type="text" ref={refTxtAnioMI} className="form-control" />
                  </Col>
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Vicepresidencia:</label>
                  <Select
                    options={comboVccMI.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO })) as any}
                    placeholder="Seleccione"
                    value={refComboVccMI || ""}
                    isClearable={true}
                    onChange={async (e: any) => {
                      setValComboVccMI(e);
                      let paramsActive = {
                        ...cParamsActive,
                        VICEPRESIDENCIA: e?.value,
                      };
                      if (e?.value) {
                        const comboGSGMI = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_GERENCIA}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;

                        setComboGSGMI([]);
                        setComboGSGMI(comboGSGMI);
                        setComboUPMI([]);
                      } else {
                        setComboGSGMI([]);
                        setComboUPMI([]);
                      }
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Gerencia/Subgerencia:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboGSGMI || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboGSGMI.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboGSGMI(e);
                      let paramsActive = {
                        ...cParamsActive,
                        NOMBRE_GERENCIA_SUBGERENCIA: e?.value,
                      };

                      if (e?.value) {
                        const comboUPMI = (
                          await getAPI(`${URL_SUPPORT}${API_ADMIN_UNIDAD}/getall`, { Authorization: `Bearer ${token}` }, paramsActive)
                        ).result.data;
                        setComboUPMI(comboUPMI);
                      } else {
                        setComboUPMI([]);
                      }
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 ajusteInput">
                <Col xs="12" md="6" lg="6">
                  <label>Unidad Proyecto:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboUPMI || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboUPMI.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboUPMI(e);
                    }}
                  />
                </Col>
                <Col xs="12" md="6" lg="6">
                  <label>Contratista/Subcontratista:</label>
                  <Select
                    placeholder="Seleccione"
                    value={refComboCSCMD || ""}
                    isClearable={true}
                    noOptionsMessage={({ inputValue }) => (!inputValue ? "No se han encontrado resultados" : "")}
                    options={comboCSCMD.map((vcc) => ({ value: vcc.TITULO, label: vcc.TITULO }))}
                    onChange={async (e: any) => {
                      setValComboCSC(e);
                    }}
                  />
                </Col>
              </div>
              <div className="row mb-2 mt-2">
                <Col xs="12" md="12" lg="12">
                  <button
                    className="btn btn-primary btn-sm me-2"
                    data-testid="btnbuscar"
                    onClick={async () => {
                      handleBuscarMI();
                    }}>
                    {" "}
                    <i className="bi bi-search"></i> Buscar
                  </button>

                  <button
                    className="btn btn-outline-primary btn-sm me-2"
                    data-testid="btnlimpiar"
                    onClick={() => {
                      (refTxtCorrMI.current as HTMLInputElement).value = "";
                      (refTxtAnioMI.current as HTMLInputElement).value = "";
                      setValComboVccMI(null);
                      setValComboUPMI(null);
                      setValComboGSGMI(null);
                      setValComboCSCMI(null);
                      setValComboEDMI(null);
                      setListItemsMI([]);
                    }}>
                    {" "}
                    <i className="bi bi-stars"></i> Limpiar Campos
                  </button>

                  {arrCambiosFormMI.length > 0 && (
                    <button
                      className="btn btn-primary btn-sm me-2 float-end"
                      onClick={() => {
                        setIsOpenPopUpGuardarCambiosMI(true);
                      }}>
                      {" "}
                      <i className="bi bi-check"></i> Guardar Cambios
                    </button>
                  )}
                </Col>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mb-1">
        <AdminLista
          reload={filtermi}
          items={[]}
          callback={editmi}
          data={listItems}
          tipo={"MantenedorDesviaciones"}
          filter={filtermi}
          pagination={{ pages: pages, page: page, paging: paging }}
          title=""
          hideAdd={true}
          hideExport={true}
          exportar={exportFileMI}
          columnsDef={columnsDef}
          hideTable={hideTable}
          callbackUpdatePageSize={(pageSize: number, filters: Object) => {
            setPageSize(pageSize);
            filtermi(filters, false, pageSize);
          }}
          isLoading={isLoading}
        />
      </div>

      {editColumnInfo && (
        <Offcanvas
          show={isEditColum}
          onHide={() => {
            setIsEditColumMI(false);
          }}
          placement={"end"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Editar - {editColumnInfo.column.columnDef.title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <div className="ajusteInput">
                <label>Valor Original</label>
              </div>
              <div>{editColumnInfo && editColumnInfo?.getValue()}</div>
            </div>
            <div className="row mb-2 ajusteInput">
              <div>
                <label>Nuevo Valor</label>
                <form className="form-control-sm">
                  {
                    <RenderForm
                      id={editColumnInfo?.column?.id}
                      tipoCampo={editColumnInfo?.column.columnDef.tipo}
                      valor={""}
                      texto={""}
                      callback={changeField}
                    />
                  }
                </form>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    let json = selectedFieldMI;
                    let arr = arrCambiosFormMI;
                    json = {
                      ID: editColumnInfo.row.original.ID_ITEM_NORMATIVO,
                      CAMPO_EDITADO: editColumnInfo.column.columnDef.title,
                      CAMPO_EDITADO_ID: editColumnInfo.column.columnDef.id,
                      VALOR_ORIGINAL: editColumnInfo?.getValue(),
                      VALOR_NUEVO:
                        editColumnInfo.column.columnDef.tipo === ITipo_Campo.user
                          ? selectedFieldMI
                          : selectedFieldMI[editColumnInfo.column.columnDef.id],
                      OBJETO_REF: editColumnInfo.row.original,
                      TIPO: editColumnInfo.column.columnDef.tipo,
                    };
                    if (!isSendingData && json.VALOR_ORIGINAL !== json.VALOR_NUEVO) {
                      arr.push(json);
                      setArrCambiosFormMI(arr);
                      setIsEditColumMI(false);
                      setIsSendingData(true);
                    }
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>

                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsEditColumMI(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      {isOpenPopUpGuardarCambiosMI && (
        <Offcanvas
          show={isOpenPopUpGuardarCambiosMI}
          onHide={() => {
            setIsOpenPopUpGuardarCambiosMI(false);
          }}
          placement={"end"}
          className={"w-50"}>
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Confirmar Cambios</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className="row mb-2">
              <span>Se realizarán los siguientes cambios en los siguientes registros de Auditoría:</span>
            </div>
            <div className="row mb-2">
              <AdminLista
                reload={filtermi}
                items={[]}
                callback={editmi}
                data={arrCambiosFormMI}
                tipo={"MantenedorDesviaciones"}
                filter={filtermi}
                pagination={{ pages: pages, page: page, paging: paging }}
                title=""
                hideAdd={true}
                hideExport={true}
                hideReload={true}
                hidePagination={true}
                columnsDef={[
                  columnHelperConfirmacionCambios.accessor((rowmi) => rowmi.ID, {
                    id: "ID",
                    cell: (infomi: CellContext<IConfirmacionMantenedor, string>) => componentValue(infomi.getValue()),
                    header: () => component("ID Registro"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowmi) => rowmi.CAMPO_EDITADO, {
                    id: "CAMPO_EDITADO",
                    cell: (infomi: CellContext<IConfirmacionMantenedor, string>) => componentValue(infomi.getValue()),
                    header: () => component("Campo Editado"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowmi) => rowmi.VALOR_ORIGINAL, {
                    id: "VALOR_ORIGINAL",
                    cell: (infomi: CellContext<IConfirmacionMantenedor, string>) => componentValue(infomi.getValue()),
                    header: () => component("Valor Original"),
                    tipo: ITipo_Campo.text,
                  } as any),
                  columnHelperConfirmacionCambios.accessor((rowmi) => rowmi.VALOR_NUEVO, {
                    id: "VALOR_NUEVO",
                    cell: (infomi: CellContext<IConfirmacionMantenedor, any>) =>
                      componentValue(
                        infomi.getValue(),
                        moment(infomi.getValue(), "YYYY-MM-DD", true).isValid() ? ITipo_Campo.date : ITipo_Campo.text
                      ),
                    header: () => component("Nuevo Valor"),
                    tipo: ITipo_Campo.text,
                  } as any),
                ]}
              />
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <label>Motivos Modificación</label>
              </div>
              <div className="col-12">
                <textarea ref={refTxtMotivo} className="w-100"></textarea>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    if (!refTxtMotivo.current?.value) {
                      refTxtMotivo.current?.classList.add("error");
                      return;
                    } else {
                      refTxtMotivo.current?.classList.remove("error");
                    }
                    MySwal.fire({
                      html: (
                        <div>
                          <h3>¿Desea realizar los cambios con el siguiente Motivo descrito?</h3>
                          <div>(se registraran las modificaciones a su nombre y cada una asociada al motivo entregado)</div>
                        </div>
                      ),
                      text: refTxtMotivo.current?.value,
                      icon: "question",
                      confirmButtonText: "Aceptar",
                      cancelButtonText: "Cancelar",
                      showCloseButton: true,
                      showCancelButton: true,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        confirm();
                      }
                    });
                  }}>
                  {" "}
                  <i className="bi bi-check"></i> Aceptar
                </button>
                <button
                  className="btn btn-outline-secondary btn-sm me-2"
                  onClick={() => {
                    setIsOpenPopUpGuardarCambiosMI(false);
                  }}>
                  {" "}
                  <i className="bi bi-x"></i> Cancelar
                </button>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      )}
      <div className="row">
        <div className="col-12">
          <CustomToast show={showToast} title="Administración" />
        </div>
      </div>
    </section>
  );
}
